import { useFormikContext } from 'formik';
import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

interface SubmitButtonProps extends ButtonProps {
    withValidation?: boolean;
    withDisabling?: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
    onClick,
    withValidation,
    withDisabling = true,
    ...props
}) => {
    const formik = useFormikContext();

    async function onClickInner() {
        if (withValidation) {
            const validated = await formik.validateForm();
            const errorKeyList = Object.keys(validated);

            if (errorKeyList.length) {
                const touchableFields: any = {};
                errorKeyList.forEach((key) => {
                    touchableFields[key] = true;
                });
                formik.setTouched(touchableFields);
                return;
            }
        }

        formik.handleSubmit();
    }

    const disabled = withDisabling && !formik.isValid;

    return <Button {...props} disabled={disabled} onClick={onClickInner} />;
};
